export default "__VITE_ASSET__DYMd32nD__"